import { NgModule, Component, NgZone, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ChatTabsModule } from '../pages/chat/chat.tabs';
import { EventService } from '../services/event.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-footer',
    template: `
    <div class="bottom-tab" [ngClass]="{'on': footerData.scrollDirection == 'down' && !miniChatEnable}">
        <dl class="circle-pop" *ngIf='!miniChatEnable'>
            <dd>
                <button aria-label="menu" class="mat-fab fab-crimson" (click)="minichatActivate('@basic1')">
                    <img src="assets/images/common/ico_chat.png" alt="채팅">
                </button>
            </dd>
        </dl>
        <mini-chat-box *ngIf='miniChatEnable' [chatFlag]=chatFlag (close)='miniChatClose($event)'></mini-chat-box>
        <div id="gnb" class="gnb hide-on-keyboard-open" *ngIf='!miniChatEnable'>
            <ul>
                <li><a [routerLink]="['/']"><img src="assets/images/common/gnb_ico_home.png" alt=""><em>홈</em></a></li>
                <li><a [routerLink]="['/market']"><img src="assets/images/common/gnb_ico_market.png" alt=""><em>마켓</em></a></li>
                <li><a [routerLink]="['/bbs']"><img src="assets/images/common/gnb_ico_comm.png" alt=""><em>커뮤니티</em></a></li>
                <li><a [routerLink]="['/mypage']"><img src="assets/images/common/gnb_ico_more.png" alt=""><em>더보기</em></a></li>
            </ul>
        </div>
    </div>
    `
})

export class FooterComponent implements OnDestroy {

    // private navCtrl: NavController;
    footerData: any = {scrollDirection: ''};
    miniChatEnable = false;
    chatFlag: any;

    // @Input() FooterObject: any;

    // 채팅창 관련 다양한 이벤트를 이곳에서 받는다.
    private subscription: Array<Subscription> = [];
    constructor(
            private eventService: EventService,
            private zone: NgZone) {
        this.subscribe();
    }

    ngOnDestroy() {
        // for (let i = 0; i < this.subscription.length; i++) {
        for (const con of this.subscription) {
            con.unsubscribe();
        }
    }


    subscribe() {
        const subscription1 = this.eventService.subscribe('chancetalk', (obj) => {
            if (obj.type === 'chanceTalkView') {
                // 창이 닫혀 있는 경우에 이것이 안됨 따라서 이 부분은 footer.ts에서 처리하여야 함
                if (typeof obj.view_mode !== 'undefined' && obj.view_mode === 'direct') {
                // 외부에서 찬스톡으로 바로 넘어온 경우
                    this.miniChatEnable = true;
                    this.chatFlag = obj;
                }
            } else { //  selectedChat: string = '' // public : , : , : 찬스톡 상세보기,  : ,  : , chatroomView 채팅방상세보기

            }
        });
        this.subscription.push(subscription1);

        const subscription2 = this.eventService.subscribe('scroll', (obj) => {
            // zone을 사용하는 이유는 빠른 반응속도를 위해서 이다.
            this.zone.run(() => this.footerData = obj);
        });
        this.subscription.push(subscription2);
    }

    minichatActivate(roomId: string, chatId?: string): void {
        this.miniChatEnable = true;
        this.chatFlag = {roomId, chatId};
    }

    miniChatClose(e: any): void {
        this.miniChatEnable = !e;
    }
}

@NgModule({
    declarations: [ FooterComponent ],
    imports: [ RouterModule, CommonModule , ChatTabsModule ],
    exports: [ FooterComponent ]
})
export class FooterModule {}
